import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Button, Paper, TextField, Popover, Select, MenuItem, Badge, Typography, Box, Stack, IconButton } from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent, timelineItemClasses } from '@mui/lab';
import { Edit, Add, Remove } from "@mui/icons-material";
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useOrdersMutation } from '../../services/ecom';
import LoadingPage from '../loadingPage';
import AlertSnackbar from '../alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import XLSX from 'xlsx-js-style';//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import DateRange from '../tools/daterange';
// import ColComboFilter from './colComboFilter';
import ColFilter from './colFilter';
import ImportExcel from './importExcel';
const API_URI = process.env.REACT_APP_API_URI;
let dateTargetRT = moment().startOf('month');

export default function Ecom() {
	const [loading, setLoading] = useState(false);
  const [orders, ordersResult] = useOrdersMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setCoumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
  const [range, setRange] = useState({from: moment().add(-7, 'days'), to: moment()});//.startOf('month')
  const [selectedRecord, setSelectedRecord] = useState("All");
  const [anchorEl, setAnchorEl] = useState(null);
	const [open, setOpen] = useState(false);
  const [permission, setPermission] = useState({});
  // const [missStatus, setMissStatus] = useState({orderStatus: 0, whStatus: 0, deliStatus: 0});
  const [dataDetail, setDataDetail] = useState(null);
  const [bulkStatus, setBulkStatus] = useState({});
  const [openImport, setOpenImport] = useState(false);
  const [dataDetailReturn, setDataDetailReturn] = useState(null);
  const gridRef = useRef();
  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([
      { make: 'Total', model: '', TOTAL: 0 }
  ]);
  const [sum, setSum] = useState([{}, {}]);
  const token = useSelector(state => state.authUser.token);
  const [dateTarget, setDateTarget] = useState(moment().startOf('month'));

  ModuleRegistry.registerModules([ AllCommunityModule ]);

  useEffect(() => {
    handleGridHeight();
    getPermission();
    getSumary();

    window.addEventListener("resize", handleGridHeight);
    return () => {
      window.removeEventListener("resize", handleGridHeight);
    };
  }, []);

  useEffect(() => {
    if (token) {
      const user = JSON.parse(window.localStorage.getItem("user"));
      if(user.id == 912)//a vu
        window.location.reload();
      else{
        getPermission();
        getSumary();
      }
    }
  }, [token]);

  const handleGridHeight = () =>{
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?divHeader.clientHeight:0) - 67);
  }

  const getPermission = async() =>{
    try {
			const formData = new FormData();
			formData.append("data", JSON.stringify({"type": "getPermission"}));
			
			const result = await orders(formData).unwrap();
			if(result)
			{
				let dt = result;
				if(typeof result === "string")
					dt = JSON.parse(result);
				if(dt.length > 0)
					setPermission(dt[0]);
			}
		} catch (error) {
			console.log(error);
		}
  }

  const getSumary = async() =>{
    try {
			const formData = new FormData();
			formData.append("data", JSON.stringify({"type": "getSumary", fromdate: moment(dateTargetRT).format('YYYY/MM/DD')}));
			
			const result = await orders(formData).unwrap();
			if(result)
			{
				let dt = result;
				if(typeof result === "string")
					dt = JSON.parse(result);

				if(dt.length > 0){
          setSum(dt);
        }
			}
		} catch (error) {
			console.log(error);
		}
  }

  const getDataView = async() =>{
    if(!range) return;
		setLoading(true);
		try {
			const formData = new FormData();
			formData.append("data", JSON.stringify({"type": "getListBills", "fromdate": moment(range.from).format('YYYY-MM-DD')
																								, "todate": moment(range.to).format('YYYY-MM-DD')}));
			
			const result = await orders(formData).unwrap();
			if(result)
			{
				let dt = result;
				if(typeof result === "string")
					dt = JSON.parse(result);

        setDataLoaded(dt);
			}
			// gridRef.current.setFilterModel(null);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
  }

  useEffect(() => {
    let mStatus = {status: 0,orderStatus: 0, whStatus: 0, deliStatus: 0, returnStatus: 0};
    
    dataLoaded.map(m=>{
      if(m.Status == "Web Orders" && (m.OrderStatus == "Xác nhận" || m.OrderStatus == "Hoàn tất"))
        mStatus.status += 1;
      if(m.OrderStatus == "Chưa xử lý" || m.OrderStatus == "Đang xử lý")
        mStatus.orderStatus += 1;
      if(m.Status == "Requested" && m.WarehouseStatus == "Chưa xử lý")
        mStatus.whStatus += 1;
      if(m.WarehouseStatus == 'Đã giao' && m.DeliStatus == 'Chưa xử lý' && moment().diff(moment(m.RequestTime), 'days') > 4)
        mStatus.deliStatus += 1;
      if(m.ReturnStatus)
        mStatus.returnStatus += 1;
    });
    
    // setMissStatus(mStatus);

    if(dataLoaded.length > 0)
        getColumns(dataLoaded[0], mStatus);
    updatePinnedBottomRow(null, dataLoaded);

		handleGridHeight();
  }, [dataLoaded]);

  const getColumns=(item, currentStatus)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key, pinned: key=='TransactionId'?'left':null,
        wrapHeaderText: true, autoHeaderHeight: true,
        wrapText: true, autoHeight: true,
        filter: (key == "Platform" || key == "Status" || key == "OrderStatus" || key == "WarehouseStatus" || key == "DeliStatus" || key == "ReturnStatus") ? ColFilter
          : (key == "BillDate" || key == "RequestTime") ? 'agTextColumnFilter' : true,
        headerName: key == "DiscountAmount" ? 'Discount' : key == "Status" ? 'Status TIV' : key == "OrderStatus" ? 'Status SOL' 
          : key == "WarehouseStatus" ? 'Status WH' : key == "DeliStatus" ? 'Status Deli' : key == "ReturnStatus" ? 'Status Return' : key.replace('__', '/ '),
        // headerComponent: key == "OrderStatus" ? CustomHeader : null,
        headerComponentParams: {
          innerHeaderComponent: key == "Status" || key == "OrderStatus" || key == "WarehouseStatus" || key == "DeliStatus" || key == "ReturnStatus" ? (props) => CustomHeader(props) : null,
          curStatus: currentStatus
        },
        sortable: key == "Platform" || key == "Status" || key == "OrderStatus" || key == "WarehouseStatus" || key == "DeliStatus" || key == "ReturnStatus" ? false : true, 
        width: key =="PartnerName" || key == "Notes" ? 250 : key == "Platform" ? 110 : key =="BillDate" ? 105 : key =="Qty" ? 80 : (key =="TransactionId" || key =="DeliStatus" || key =="ReturnStatus") ? 165 : key =="Shipping" ? 300 : 150,
        cellStyle: () => ((key=="Qty" || key=="SumAmount" || key=="DiscountAmount" || key=="ShippingTotal" || key=="PointDiscount" || key=="InvoiceTotal")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="TotalNet" ? "bold" : ""
        }:(key == "TransactionId"||key == "Platform"||key == "BillDate")?{display: "flex", justifyContent: "center"}:null),
        // valueFormatter: params => params.data[key] && (
        //   key=="BillDate"?moment(params.data[key]).format("DD/MM/YYYY"):params.data[key]
        //   //:(key=="Order" || key=="D2C" || key=="ECOM" || key=="B2B")?new Intl.NumberFormat('en-US').format(params.data[key]):params.data[key]
        // ),
        filterValueGetter: (params) => {
          return key=="BillDate" && params.data.BillDate ? moment(params.data[key]).format("DD/MM/YYYY")
            : key=="RequestTime" && params.data.RequestTime ? moment(params.data[key]).format("DD/MM/YYYY HH:mm") 
            : params.data[key];
        },
        hide: (key=="id"||key=="OrderStatusTime"||key=="Remarks"||key=="WhStatusTime"||key=="DeliStatusTime"||key=="StatusTime"?true
              :(key=="Platform" && !permission.Platform)?true:false),
        cellRenderer: (props) => CustomCell(props, key)
      }
    });
    setCoumns(cols);
  }

  const CustomCell = (props, key) => {
    if(key=="TransactionId")
      return <a onClick={(e)=>onShowDetail(e, props.data.id, props.data.Platform)} style={{color: 'blue', cursor: 'pointer'}}>{props.value}</a>;
    else if(key=="BillDate")
      return props.value?moment(props.value).format("DD/MM/YYYY"):'';
    else if(key=="RequestTime")
      return props.value?moment(props.value).format("DD/MM/YYYY HH:mm"):'';
    else if(key=="Qty" || key=="SumAmount" || key=="DiscountAmount" || key=="ShippingTotal" || key=="PointDiscount" || key=="InvoiceTotal")
      return new Intl.NumberFormat('en-US').format(props.value);
    else if(key=="Status"){
      return <div style={{float: 'left', width: '100%', lineHeight: props.data.StatusTime?'1.2em':''
                            , margin: props.data.StatusTime?'6px 0':''}}>
              <span style={{float: 'left', width: '100%'}}>{props.value}</span>
          {props.data.StatusTime?<span style={{float: 'left', width: '100%', fontSize: '0.9em', fontStyle: 'italic', color: '#5b7361'}}>{moment(props.data.StatusTime).format('DD/MM/YYYY HH:mm')}</span>:''}
        </div>;
    }
    else if(key=="OrderStatus"){
      return <div style={{float: 'left', width: '100%', lineHeight: props.data.OrderStatusTime?'1.2em':''
                            , margin: props.data.OrderStatusTime?'6px 0':''}}>
              <span style={{float: 'left', width: '100%'}}>{permission.OrderStatus && props.value?<Edit onClick={(e)=>onCellClick(e, props.data, key)} style={{fontSize: '12px', cursor: 'pointer'}}/>:''} &nbsp;{props.value}</span>
          {props.data.OrderStatusTime?<span style={{float: 'left', width: '100%', fontSize: '0.9em', fontStyle: 'italic', color: '#5b7361'}}>{moment(props.data.OrderStatusTime).format('DD/MM/YYYY HH:mm')}</span>:''}
              <a style={{color: 'blue', fontStyle: 'italic', whiteSpace: 'nowrap'}}>{props.data.Remarks}</a>
        </div>;
    }
    else if(key=="WarehouseStatus"){
      return <div style={{float: 'left', width: '100%', lineHeight: props.data.WhStatusTime?'1.2em':''
                            , margin: props.data.WhStatusTime?'6px 0':''}}>
              <span style={{float: 'left', width: '100%'}}>{permission.WarehouseStatus && props.data.Status=='Requested' && props.value?<Edit onClick={(e)=>onCellClick(e, props.data, key)} style={{fontSize: '12px', cursor: 'pointer'}}/>:''} &nbsp;{props.value}</span>
          {props.data.WhStatusTime?<span style={{float: 'left', width: '100%', fontSize: '0.9em', fontStyle: 'italic', color: '#5b7361'}}>{moment(props.data.WhStatusTime).format('DD/MM/YYYY HH:mm')}</span>:''}
        </div>;
    }
    else if(key=="DeliStatus"){
      const alert = (props.data.WarehouseStatus == 'Đã giao' && props.data.DeliStatus == 'Chưa xử lý' && moment().diff(moment(props.data.RequestTime), 'days') > 4) ? true : false;

      return <div style={{float: 'left', width: '100%', lineHeight: props.data.DeliStatusTime?'1.2em':''
                            , margin: props.data.DeliStatusTime?'6px 0':''}}>
              <span style={{float: 'left', width: '100%', color: alert ? 'red' : ''}}>{permission.DeliStatus && props.data.WarehouseStatus=='Đã giao' && props.value=='Chưa xử lý'?
                <Edit onClick={(e)=>onCellClick(e, props.data, key)} style={{fontSize: '12px', cursor: 'pointer'}}/>:''} &nbsp;{props.value}</span>
          {props.data.DeliStatusTime?<span style={{float: 'left', width: '100%', fontSize: '0.9em', fontStyle: 'italic', color: '#5b7361'}}>{moment(props.data.DeliStatusTime).format('DD/MM/YYYY HH:mm')}</span>:''}
        </div>;
    }
    else if(key=="ReturnStatus"){
      return <div style={{float: 'left', width: '100%'}}>
              <span style={{float: 'left', width: '100%', lineHeight: '1.2em', margin: '6px 0'}}>{permission.ReturnStatus && props.value != 'Kho đã nhận hàng' ?
                <Edit onClick={(e)=>onCellClick(e, props.data, key)} style={{fontSize: '12px', cursor: 'pointer'}}/>:''}
                {props.value == 'Kho đã nhận hàng' ?<span onClick={(e)=>onShowDetailReturn(e, props.data, key)} style={{cursor: 'pointer', color: 'blue'}}>{props.value}</span>
                : <span> &nbsp;{props.value}</span>}
              </span>
        </div>;
    }
    else if(key=="Notes"){
      return <div style={{float: 'left', width: '100%'}}>
              <span style={{float: 'left', width: '100%', lineHeight: '1.2em', margin: '6px 0'}}>{permission.Notes ?
                <Edit onClick={(e)=>onCellClick(e, props.data, key)} style={{fontSize: '12px', cursor: 'pointer'}}/>:''} &nbsp;{props.value}</span>
        </div>;
    }
    else return props.value;
  };

  const CustomHeader = (props) => {
    const handleFilterClick = async() => {
      gridRef.current.setFilterModel({}); //clear all filter
      if(props.displayName == 'Status TIV'){
        gridRef.current.setColumnFilterModel('OrderStatus',['Xác nhận','Hoàn tất']).then(() => {
          setTimeout(()=>{
            gridRef.current.onFilterChanged();
          }, 100);
        });
      }
      else if(props.displayName == 'Status WH'){
        gridRef.current.setColumnFilterModel('Status', ['Requested']).then(() => {
          setTimeout(()=>{
            gridRef.current.onFilterChanged();
          }, 100);
        });
      }
      else if(props.displayName == 'Status Deli'){
        gridRef.current.setColumnFilterModel('WarehouseStatus', ['Đã giao']).then(() => {
          setTimeout(()=>{
            gridRef.current.onFilterChanged();
          }, 100);
        });
      }
      else if(props.displayName == 'Status Return'){
        gridRef.current.setColumnFilterModel('ReturnStatus', ['Khách hàng trả hàng', 'Kho đã nhận hàng']).then(() => {
          setTimeout(()=>{
            gridRef.current.onFilterChanged();
          }, 100);
        });
      }

      if(props.displayName == 'Status SOL'){
        gridRef.current.setColumnFilterModel('OrderStatus',['Chưa xử lý','Đang xử lý']).then(() => {
          setTimeout(()=>{
            gridRef.current.onFilterChanged();
          }, 100);
        });
      }
      else
        gridRef.current.setColumnFilterModel(props.displayName == 'Status TIV' ? 'Status' : 
                                          props.displayName == 'Status SOL' ? 'OrderStatus' : 
                                           props.displayName == 'Status WH' ? 'WarehouseStatus' : 
                                           props.displayName == 'Status Deli' ? 'DeliStatus' : '',
                                           props.displayName == 'Status TIV' ? ['Web Orders'] : ['Chưa xử lý']).then(() => {
          setTimeout(()=>{
            gridRef.current.onFilterChanged();
          }, 100);
        });
    };

    return (
      <Badge 
        badgeContent={props.curStatus?(props.displayName == 'Status TIV' ? props.curStatus.status : 
                                      props.displayName == 'Status SOL' ? props.curStatus.orderStatus : 
                                      props.displayName == 'Status WH' ? props.curStatus.whStatus : 
                                      props.displayName == 'Status Deli' ? props.curStatus.deliStatus : 
                                      props.displayName == 'Status WH' ? props.curStatus.whStatus : 
                                      props.displayName == 'Status Return' ? props.curStatus.returnStatus : 0):0} 
        color='warning' max={999}
        style={{ cursor: 'pointer', margin: '11px 15px 10px 0' }} 
        onClick={handleFilterClick}
      >
        <span style={{ paddingRight: '5px' }}>{props.displayName}</span>
      </Badge>
    );
  };

  const onGridReady = useCallback((params) => {
    gridRef.current = params.api;
    updatePinnedBottomRow(params.api); // Initial calculation
  }, []);

  const updatePinnedBottomRow = (api, data) => {
    let Qty = 0, SumAmount = 0, DiscountAmount = 0, ShippingTotal = 0, PointDiscount = 0, InvoiceTotal = 0, countR = 0;
    if(data){
      data.map(m=>{
        Qty += m.Qty;
        SumAmount += m.SumAmount;
        DiscountAmount += m.DiscountAmount;
        ShippingTotal += m.ShippingTotal;
        PointDiscount += m.PointDiscount;
        InvoiceTotal += m.InvoiceTotal;
      });
      countR = data.length;
    }
    else{
      api.forEachNodeAfterFilter((node) => {
        Qty += node.data.Qty;
        SumAmount += node.data.SumAmount;
        DiscountAmount += node.data.DiscountAmount;
        ShippingTotal += node.data.ShippingTotal;
        PointDiscount += node.data.PointDiscount;
        InvoiceTotal += node.data.InvoiceTotal;
        countR ++;
      });
    }

    setPinnedBottomRowData([{ make: 'Total', model: '', TransactionId: <label style={{color: '#ff7300'}}>{countR}</label>
      , Qty: Qty, SumAmount: SumAmount, DiscountAmount: DiscountAmount
      , ShippingTotal: ShippingTotal, PointDiscount: PointDiscount, InvoiceTotal: InvoiceTotal
    }]);
  };

  const onFilterChanged = useCallback(() => {
    if (gridRef.current) {
        updatePinnedBottomRow(gridRef.current);
    }
  }, []);

  const exportExcel = () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(dataLoaded, { origin: 3 });
    ws['!cols'] = [
      { wch: 20 }, // Column A
      { wch: 30 } // Column B
    ];
    XLSX.utils.sheet_add_aoa(ws, [
      [{v: 'ECOMMERCE', t: "s", s: {font: { bold: true }}}],
      ['From', moment(range.from).format('DD-MMM-YY'), '', '', '', 'Number od day'],
      ['To', moment(range.to).format('DD-MMM-YY'), '', '', '', moment(range.to).diff(moment(range.from), 'days')]
    ], { origin: 'A1' });
    for(var i=0; i<Object.keys(dataLoaded[0]).length; i++){
      var cell_address = { c: i, r: 3 };//column, row
      var cell_ref = XLSX.utils.encode_cell(cell_address);
      ws[cell_ref].s = {// font: { name: "Arial", sz: 14, bold: true, color: { rgb: "000000" } },// alignment: { horizontal: "left", vertical: "center" }
        fill: { fgColor: { rgb: "EFEFEF" } },
      };
    }
    
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    saveAs(data, "EcomOrders.xlsx");
  }

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

	const onCellClick=(e, record, key)=>{
		setAnchorEl(e.currentTarget); 
		setSelectedRecord({...record, showDetail: false});
		setOpen(key);
    if(key == "OrderStatusBulk" || key == "WarehouseStatusBulk")
      setBulkStatus({});
    setDataDetailReturn(null);
	}

	const onShowDetailReturn=(e, record, key)=>{
		setAnchorEl(e.currentTarget); 
		setSelectedRecord(record);
		setOpen(key);
    handleChangeOrder(record.ReturnStatus, key, record, true);
	}

	const handleChangeOrder = async (value, field, record, showDetail) =>{
    if(open == "OrderStatusBulk" || open == "WarehouseStatusBulk"){
      setBulkStatus({...bulkStatus, [`${field}`]: value});
      return;
    }
		setSelectedRecord({...record, [`${field}`]: value, showDetail: showDetail});
    setDataDetailReturn(null);
    if(field == 'ReturnStatus' && value == 'Kho đã nhận hàng'){
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("data", JSON.stringify({"type": "getDetailReturns", "id": record.id, "platform": record.Platform}));
        
        const result = await orders(formData).unwrap();
        if(result)
        {
          let dt = result;
          if(typeof result === "string")
            dt = JSON.parse(result);

          const detail = JSON.parse(Object.values(dt[0])[0])[0];
          if(detail && detail.details && detail.details.length){
            let dtl = [];
            detail.details.map((m, index)=>{
              let qty = m.qty;
              let dt = {...m, qty: 1};
              if(qty > 0){
                for(var i = 1; i < qty; i++){
                  dtl.push({...dt, key: `${index}_${i}`});
                }
              }
              dtl.push({...dt, key: `${index}_${i}`});
              // m.reuse = m.qty;
            });
            const sortedData = [...dtl].sort((a, b) => {
              return a.style.localeCompare(b.style) || 
                    a.color.localeCompare(b.color) || a.size.localeCompare(b.size);
            });
            setDataDetailReturn(sortedData);
          }
        }
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }
	}

  const onSaveOrder = async() =>{
    if(open == "OrderStatusBulk" || open == "WarehouseStatusBulk"){
      onSaveBulkStatus();
      return;
    }

		setLoading(true);
		try {
			const formData = new FormData();
      let value2 = selectedRecord.Remarks; //SOL
      if(open == 'ReturnStatus' && selectedRecord[`${open}`] == 'Kho đã nhận hàng')
        dataDetailReturn.map(m=> {value2 = `${value2||''}${m.id}|${m.qty}|${m.remarks||''}#`});
      
			formData.append("data", JSON.stringify({"type": `save${open}`, "id": selectedRecord.id
																								, "value": selectedRecord[`${open}`]
                                                , "value2": value2
                                                , "platform": selectedRecord.Platform}));
			
			let result = await orders(formData).unwrap();
      if(typeof result === "string")
					result = JSON.parse(result);
			if(result && result.length > 0 && result[0].id){
        setOpen(false);
        setSnackContent("Đã lưu trạng thái đơn hàng!");
        let datachange = [...dataLoaded];
        let itemchange = datachange.find(f=>f.id == selectedRecord.id);
        itemchange[`${open}`] = selectedRecord[`${open}`];
        if(open == "OrderStatus"){
          itemchange.OrderStatusTime = moment().format("YYYY-MM-DD HH:mm:ss");
          itemchange.Remarks = selectedRecord.Remarks;
        }
        else if(open == "WarehouseStatus"){
          itemchange.WhStatusTime = moment().format("YYYY-MM-DD HH:mm:ss");
        }
        else if(open == "DeliStatus"){
          itemchange.DeliStatusTime = moment().format("YYYY-MM-DD HH:mm:ss");
        }
        setDataLoaded(datachange);
      }
      else if(result && result.length > 0 && result[0].BARCODE){
        let strStock = "";
        result.map(m=>{strStock += `BARCODE: ${m.BARCODE}, SOH: ${m.SOH}; `});
        setSnackContent("Lỗi tồn kho không đủ: " + strStock);
      }
      else
        setSnackContent("Chưa thể lưu, vui lòng thử lại!");
		} catch (error) {
			console.log(error);
      setSnackContent("Chưa thể lưu, vui lòng thử lại!");
		}
		setLoading(false);
  }

  const onShowDetail = async(e, id, platform) => {
    setAnchorEl(e.currentTarget); 
    
    if(!range) return;
		setLoading(true);
		try {
			const formData = new FormData();
			formData.append("data", JSON.stringify({"type": "getDetails", "id": id, "platform": platform}));
			
			const result = await orders(formData).unwrap();
			if(result)
			{
				let dt = result;
				if(typeof result === "string")
					dt = JSON.parse(result);

        const detail = JSON.parse(Object.values(dt[0])[0])[0];
        setDataDetail(detail);
			}
			// gridRef.current.setFilterModel(null);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
  }

  const onGridSelectChange = useCallback(() => {
    // Force re-render to update the bulk action buttons visibility
    setSelectedRecord({...selectedRecord});
  }, [selectedRecord]);

  const onSaveBulkStatus = async () => {
    const selectedNodes = gridRef.current.getSelectedNodes();
    if (selectedNodes.length === 0) {
      setSnackContent("Vui lòng chọn ít nhất một dòng!");
      return;
    }
    let platform = null;
    if(selectedNodes.find(f=>f.data.Platform == 'Web')){
      platform = 'Web';
    }
    if(selectedNodes.find(f=>f.data.Platform == 'Shopee')){
      if(open == "OrderStatusBulk"){
        setSnackContent("Vui lòng chỉ chọn Platform Web!");
        return;
      }
      if(platform){
        setSnackContent("Vui lòng chỉ chọn 1 Platform!");
        return;
      }
      platform = 'Shopee';
    }
    if(selectedNodes.find(f=>f.data.Platform == 'Lazada')){
      if(open == "OrderStatusBulk"){
        setSnackContent("Vui lòng chỉ chọn Platform Web!");
        return;
      }
      if(platform){
        setSnackContent("Vui lòng chỉ chọn 1 Platform!");
        return;
      }
      platform = 'Lazada';
    }

    setLoading(true);
    try {
      // Extract IDs from selected rows
      const ids = selectedNodes.map(node => node.data.id);
      
      const formData = new FormData();
      // Assuming your backend can handle a "bulk" type or you loop them
      formData.append("data", JSON.stringify({
        "type": `save${open}`, // Update your backend to handle multiple IDs
        "ids": ids.toString(), 
        "value": bulkStatus[`${open.replace('Bulk', '')}`], // Extract the actual field name
        "value2": bulkStatus.Remarks,
        "platform": platform
      }));

      const result = await orders(formData).unwrap();

      if (result) {
        setSnackContent(`Đã cập nhật ${ids.length} đơn hàng!`);
        
        // Update local state so the grid refreshes without a reload
        let newData = [...dataLoaded];
        ids.forEach(id => {
          let item = newData.find(f => f.id === id);
          if (item) {
            if(open == "WarehouseStatusBulk"){//trang thai don hang la web orders moi doi trang thai giao hang
              if(item.Status != "Web Orders"){
                item[`${open.replace('Bulk', '')}`] = bulkStatus[`${open.replace('Bulk', '')}`];
                item.WhStatusTime = moment().format("YYYY-MM-DD HH:mm:ss");
              }
              return;
            }

            item[`${open.replace('Bulk', '')}`] = bulkStatus[`${open.replace('Bulk', '')}`];
            if(open == "OrderStatusBulk"){
              item.OrderStatusTime = moment().format("YYYY-MM-DD HH:mm:ss");
              item.Remarks = bulkStatus.Remarks;
            }
          }
        });
        setDataLoaded(newData);
        gridRef.current.deselectAll(); // Clear selection after saving
        setOpen(false);
      }
    } catch (error) {
      console.error(error);
      setSnackContent("Lỗi khi lưu hàng loạt!");
    }
    setLoading(false);
  };

  const onChangeColQty=async(index, value, type, record)=>{
    try {
      let dtl = [...dataDetailReturn];
      let qty = parseInt(record.reuse);
      if(type == 'change')
        qty = value || 0;
      else
        qty = qty + value;

      if(qty > record.qty || qty < 0)
        return;
      dtl[index].reuse = qty;
      setDataDetailReturn(dtl);
    } catch (err) {
      console.error(err);
    }
  }

  const onChangeColRemarks=async(index, value, record)=>{
    try {
      let dtl = [...dataDetailReturn];
      dtl[index].remarks = value.replace('`', '').replace('#', '').replace('|', '');
      setDataDetailReturn(dtl);
    } catch (err) {
      console.error(err);
    }
  }

  const handleChangeDateTarget=(value)=>{
		dateTargetRT = value;
		setDateTarget(dateTargetRT);
	}

	const onChangeDateTarget=()=>{
		getSumary();
	}

  return (
    <div style={{padding: '0 10px'}}>
      { (loading) && <LoadingPage /> }
      <div style={{marginTop: '5px'}}>
        <Box id='divHeader' sx={{ width: '100%', float: 'left' }}>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{
              overflowX: 'auto', pt: 1, mb: 0.5,
              pb: 0.5, // Space for the scrollbar so it doesn't touch the buttons
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#ccc',
                borderRadius: '10px',
              },
              // Ensure items don't shrink and stay on one line
              flexWrap: 'nowrap',
              float: 'left'
            }}
          >
            <Box sx={{ flexShrink: 0 }}>
              <DateRange range={range} setRange={setRange} sx={{float: 'left'}} />
            </Box>
            <Button variant="contained" onClick={getDataView}
              sx={{ flexShrink: 0}}>View</Button>
            <Button variant="contained" onClick={exportExcel}
              sx={{ flexShrink: 0 }}>Export</Button>
            {permission.OrderStatus && gridRef.current && gridRef.current.getSelectedNodes().length > 1 ?
              <Button variant="contained" color="success" onClick={(e)=>onCellClick(e, gridRef.current.getSelectedNodes(), 'OrderStatusBulk')}
                sx={{ flexShrink: 0 }}>Change Status SOL</Button>:''}
            {permission.WarehouseStatus && gridRef.current && gridRef.current.getSelectedNodes().length > 1 ?
              <Button variant="contained" color="success" onClick={(e)=>onCellClick(e, gridRef.current.getSelectedNodes(), 'WarehouseStatusBulk')}
                sx={{ flexShrink: 0 }}>Change Status Warehouse</Button>:''}
            {permission.DeliStatus ?
              <Button variant="contained" color="warning" onClick={(e)=>setOpenImport('DeliStatus')}
                sx={{ flexShrink: 0 }}>Import Deli Status</Button>:''}
            
            {/* <span>Issued: </span><span style={{color: 'blue'}}>{new Intl.NumberFormat('en-US').format(sum[0].issued)}</span>
            <span>On the way: </span><span style={{color: 'orange'}}>{new Intl.NumberFormat('en-US').format(sum[0].waiting)}</span>
            <span>New: </span><span style={{color: 'green'}}>{new Intl.NumberFormat('en-US').format(sum[0].new)}</span> */}
          </Stack>
          
          <Box sx={{display: 'flex', flexDirection: 'row', columnGap: '5px', float: 'right'}}>
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
              <Box>
                <Box sx={{float: 'left', height: '16px'
                        , '& .MuiStack-root': {padding: '2px', overflow: 'hidden', width: '100px'}
                        , '& .MuiPickersSectionList-root': {padding: 0}, '& .MuiInputAdornment-root': {margin: 0}
                        , '& .MuiPickersTextField-root': {minWidth: 0}
                        , '& .MuiPickersInputBase-root': {fontWeight: 'bold', padding: '2px 12px 0 5px', width: '100px'}
                        , '& .MuiButtonBase-root': {height: '20px', padding: '0px'} }}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DemoContainer components={['DatePicker', 'DatePicker', 'DatePicker']}>
                      <DatePicker label={''} views={['month', 'year']} format="MMM YYYY" 
                      value={dateTarget} onChange={handleChangeDateTarget} onClose={onChangeDateTarget} />
                    </DemoContainer>
                  </LocalizationProvider>
                </Box>

                <span style={{fontWeight: 'bold', marginRight: '3px', float: 'right'}}>Isued Total: {new Intl.NumberFormat('en-US').format((sum[0].CM_TOTAL||0) + (sum[0].LM_TOTAL||0))}</span>
              </Box>
              <table style={{marginTop: '5px'}}>
                <tr style={{color: 'blue'}}>
                  <td style={{paddingRight: '5px', borderRight: '1px dashed silver'}}>CM: {new Intl.NumberFormat('en-US').format(sum[0].CM_TOTAL||0)}</td>
                  <td style={{padding: '0 5px', borderRight: '1px dashed silver'}}>WEB: {new Intl.NumberFormat('en-US').format(sum[0].CM_WEB||0)}</td>
                  <td style={{padding: '0 5px', borderRight: '1px dashed silver'}}>SHP: {new Intl.NumberFormat('en-US').format(sum[0].CM_SP||0)}</td>
                  <td style={{paddingLeft: '5px'}}>LZD: {new Intl.NumberFormat('en-US').format(sum[0].CM_LZD||0)}</td>
                </tr>
                <tr>
                  <td style={{paddingRight: '5px', borderRight: '1px dashed silver'}}>PM: {new Intl.NumberFormat('en-US').format(sum[0].LM_TOTAL||0)}</td>
                  <td style={{padding: '0 5px', borderRight: '1px dashed silver'}}>WEB: {new Intl.NumberFormat('en-US').format(sum[0].LM_WEB||0)}</td>
                  <td style={{padding: '0 5px', borderRight: '1px dashed silver'}}>SHP: {new Intl.NumberFormat('en-US').format(sum[0].LM_SP||0)}</td>
                  <td style={{paddingLeft: '5px'}}>LZD: {new Intl.NumberFormat('en-US').format(sum[0].LM_LZD||0)}</td>
                </tr>
              </table>
            </Box>
            <Box sx={{borderLeft: '1px solid silver', display: 'flex', flexDirection: 'column', paddingLeft: '5px'}}>
              <Box>
                <span style={{fontWeight: 'bold', marginRight: '3px', float: 'right'}}>SBNI: {new Intl.NumberFormat('en-US').format((sum[1].CM_TOTAL||0) + (sum[1].LM_TOTAL||0))}</span>
              </Box>
              <table style={{marginTop: '5px'}}>
                <tr style={{color: 'blue'}}>
                  <td style={{paddingRight: '5px', borderRight: '1px dashed silver'}}>CM: {new Intl.NumberFormat('en-US').format(sum[1].CM_TOTAL||0)}</td>
                  <td style={{padding: '0 5px', borderRight: '1px dashed silver'}}>WEB: {new Intl.NumberFormat('en-US').format(sum[1].CM_WEB||0)}</td>
                  <td style={{padding: '0 5px', borderRight: '1px dashed silver'}}>SHP: {new Intl.NumberFormat('en-US').format(sum[1].CM_SP||0)}</td>
                  <td style={{paddingLeft: '5px'}}>LZD: {new Intl.NumberFormat('en-US').format(sum[1].CM_LZD||0)}</td>
                </tr>
                <tr>
                  <td style={{paddingRight: '5px', borderRight: '1px dashed silver'}}>PM: {new Intl.NumberFormat('en-US').format(sum[1].LM_TOTAL||0)}</td>
                  <td style={{padding: '0 5px', borderRight: '1px dashed silver'}}>WEB: {new Intl.NumberFormat('en-US').format(sum[1].LM_WEB||0)}</td>
                  <td style={{padding: '0 5px', borderRight: '1px dashed silver'}}>SHP: {new Intl.NumberFormat('en-US').format(sum[1].LM_SP||0)}</td>
                  <td style={{paddingLeft: '5px'}}>LZD: {new Intl.NumberFormat('en-US').format(sum[1].LM_LZD||0)}</td>
                </tr>
              </table>
            </Box>
          </Box>
        </Box>
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left', position: 'relative' }}>
          <AgGridReact
            enableCellTextSelection={true} ensureDomOrder={true}
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={200}
            paginationPageSizeSelector={[200, 500, 1000]}
            pinnedBottomRowData={pinnedBottomRowData}
            getRowClass={getRowClass}
            theme={theme}
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
            onSelectionChanged={onGridSelectChange}
            gridOptions={{rowSelection: {
                mode: 'multiRow', // Changed from 'singleRow'
                headerCheckbox: true, // Adds a "Select All" checkbox in the header
                checkboxes: true, // Adds checkboxes to the rows
                enableClickSelection: true,
                selectAll: 'filtered'
            }}}
          />
        </Paper>
				<Popover
					open={open=="OrderStatus" || open == "OrderStatusBulk"}
					anchorEl={anchorEl}
					onClose={()=>setOpen(false)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
				>
					<div style={{width: '400px', padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={selectedRecord.OrderStatus}
							label=""
							onChange={(e)=>handleChangeOrder(e.target.value, 'OrderStatus', selectedRecord)}
							style={{width: '200px', float: 'left'}}
							size='small'
						>
							<MenuItem value={'Chưa xử lý'}>Chưa xử lý</MenuItem>
							<MenuItem value={'Đang xử lý'}>Đang xử lý</MenuItem>
							<MenuItem value={'Hủy đơn'}>Hủy đơn</MenuItem>
							<MenuItem value={'Xác nhận'}>Xác nhận</MenuItem>
							<MenuItem value={'Hoàn tất'}>Hoàn tất</MenuItem>
						</Select>
            <TextField value={selectedRecord.Remarks} onChange={(e)=>handleChangeOrder(e.target.value, 'Remarks', selectedRecord)} size='small' multiline rows={2} 
              placeholder="Remarks" style={{textAlign: 'left', width: '100%', float: 'left'}}/>
						<Button variant="contained" sx={{ margin: '2px', float: 'left' }} 
              onClick={onSaveOrder} loading={loading}>SAVE</Button>
					</div>
				</Popover>

        <Popover
					open={open=="WarehouseStatus" || open == "WarehouseStatusBulk"}
					anchorEl={anchorEl}
					onClose={()=>setOpen(false)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
				>
					<div style={{width: '285px', padding: '10px', display: 'flex', flexDirection: 'row', gap: '10px'}}>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={selectedRecord.WarehouseStatus}
							label=""
							onChange={(e)=>handleChangeOrder(e.target.value, 'WarehouseStatus', selectedRecord)}
							style={{width: '200px', float: 'left'}}
							size='small'
						>
							<MenuItem value={'Chưa xử lý'}>Chưa xử lý</MenuItem>
							<MenuItem value={'Đã giao'}>Đã giao</MenuItem>
							<MenuItem value={'Hủy'}>Hủy</MenuItem>
						</Select>
						<Button variant="contained" sx={{ margin: '2px', float: 'left' }} 
              onClick={onSaveOrder} loading={loading}>SAVE</Button>
					</div>
				</Popover>

        <Popover
					open={open=="DeliStatus"}
					anchorEl={anchorEl}
					onClose={()=>setOpen(false)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
				>
					<div style={{width: '285px', padding: '10px', display: 'flex', flexDirection: 'row', gap: '10px'}}>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={selectedRecord.DeliStatus}
							label=""
							onChange={(e)=>handleChangeOrder(e.target.value, 'DeliStatus', selectedRecord)}
							style={{width: '200px', float: 'left'}}
							size='small'
						>
							<MenuItem value={'Chưa xử lý'}>Chưa xử lý</MenuItem>
							<MenuItem value={'Giao thành công'}>Giao thành công</MenuItem>
						</Select>
						<Button variant="contained" sx={{ margin: '2px', float: 'left' }} 
              onClick={onSaveOrder} loading={loading}>SAVE</Button>
					</div>
				</Popover>

        <Popover
					open={open=="ReturnStatus"}
					anchorEl={anchorEl}
					onClose={()=>setOpen(false)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
				>
					<div style={{padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
            <div style={{flexDirection: 'row', gap: '10px'}}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedRecord.ReturnStatus}
                label=""
                onChange={(e)=>handleChangeOrder(e.target.value, 'ReturnStatus', selectedRecord)}
                style={{width: '200px', float: 'left'}}
                size='small'
                disabled={selectedRecord.showDetail}
              >
                <MenuItem value={''}></MenuItem>
                <MenuItem value={'Khách hàng trả hàng'}>Khách hàng trả hàng</MenuItem>
                <MenuItem value={'Kho đã nhận hàng'}>Kho đã nhận hàng</MenuItem>
              </Select>
              {!selectedRecord.showDetail ?
              <Button variant="contained" sx={{ margin: '2px', float: 'left' }} 
                onClick={onSaveOrder} loading={loading}>SAVE</Button> : ''}
            </div>
            {dataDetailReturn && dataDetailReturn.length > 0 &&
            <div style={{width: '700px'}}>
              <span style={{color: 'blue'}}>* Hệ thống sẽ tự động tạo phiếu Return ngay sau khi SAVE xác nhận kho đã nhận hàng.</span>
              <table style={{borderCollapse: 'collapse', width: '100%', float: 'left'}}>
                <thead>
                  <tr style={{backgroundColor: '#a0a0a0'}}>
                    <th style={{border: '1px solid #000000'}}>Style</th>
                    <th style={{border: '1px solid #000000'}}>Color</th>
                    <th style={{border: '1px solid #000000'}}>Size</th>
                    <th style={{border: '1px solid #000000'}}>Price</th>
                    <th style={{border: '1px solid #000000'}}>Qty</th>
                    <th style={{border: '1px solid #000000'}}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {dataDetailReturn.map((item, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid #000000', padding: '0 5px', whiteSpace: 'nowrap'}}>{item.style}</td>
                      <td style={{border: '1px solid #000000', padding: '0 5px'}}>{item.color}</td>
                      <td style={{border: '1px solid #000000', padding: '0 5px'}}>{item.size}</td>
                      <td style={{border: '1px solid #000000', textAlign: 'right', padding: '0 5px'}}>{new Intl.NumberFormat('en-US').format(item.price)}</td>
                      <td style={{border: '1px solid #000000', textAlign: 'center', padding: '0 5px'}}>{item.qty}</td>
                      <td style={{border: '1px solid #000000', textAlign: 'right', padding: '0', width: '400px'}}>
                        <TextField size="small" sx={{ width: '400px', maxWidth: '400px' }}
                          value={item.remarks} onChange={(e) => onChangeColRemarks(index, e.target.value, item)}></TextField>
                        {/* <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
                          <IconButton onClick={() => onChangeColQty(index, -1, 'add', item)} size="small">
                            <Remove />
                          </IconButton>
                          <TextField
                            size="small"
                            value={item.reuse}
                            sx={{ width: 55, mx: 1 }}
                            onChange={(e) => onChangeColQty(index, e.target.value||0, 'change', item)}
                            slotProps={{
                              input: {
                                inputProps: {
                                  inputMode: 'numeric',
                                  pattern: '[0-9]*',
                                  style: { textAlign: "center" },
                                  maxLength: 3
                                }
                              }
                            }}
                          />
                          <IconButton onClick={() => onChangeColQty(index, 1, 'add', item)} size="small">
                            <Add />
                          </IconButton>
                        </Box> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            }
					</div>
				</Popover>

        <Popover
					open={open=="Notes"}
					anchorEl={anchorEl}
					onClose={()=>setOpen(false)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
				>
					<div style={{width: '285px', padding: '10px', display: 'flex', flexDirection: 'row', gap: '10px'}}>
						<TextField value={selectedRecord.Notes} onChange={(e)=>handleChangeOrder(e.target.value, 'Notes', selectedRecord)} size='small' multiline rows={2} 
              placeholder="Notes" style={{textAlign: 'left', width: '100%', float: 'left'}}/>
						<Button variant="contained" sx={{ margin: '2px', float: 'left' }} 
              onClick={onSaveOrder} loading={loading}>SAVE</Button>
					</div>
				</Popover>

        <Popover
					open={dataDetail!=null}
					anchorEl={anchorEl}
					onClose={()=>setDataDetail(null)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
				>
					<div style={{width: '420px', padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
						{dataDetail && Object.keys(dataDetail).length > 0 &&
              <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                <span><b>TransactionId:</b> {dataDetail.transactionid}</span>
                <span><b>BillDate:</b> {moment(dataDetail.billdate).format('DD/MM/YYYY')}</span>
                <span><b>Total:</b> {new Intl.NumberFormat('en-US').format(dataDetail.total)}</span>
              </div>
            }
            {dataDetail && dataDetail.details && dataDetail.details.length > 0 &&
              <table style={{borderCollapse: 'collapse', width: '100%'}}>
                <thead>
                  <tr style={{backgroundColor: '#a0a0a0'}}>
                    <th style={{border: '1px solid #000000'}}>Style</th>
                    <th style={{border: '1px solid #000000'}}>Color</th>
                    <th style={{border: '1px solid #000000'}}>Size</th>
                    <th style={{border: '1px solid #000000'}}>Price</th>
                    <th style={{border: '1px solid #000000'}}>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {dataDetail.details.map((item, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid #000000', padding: '0 5px'}}>{item.style}</td>
                      <td style={{border: '1px solid #000000', padding: '0 5px'}}>{item.color}</td>
                      <td style={{border: '1px solid #000000', padding: '0 5px'}}>{item.size}</td>
                      <td style={{border: '1px solid #000000', textAlign: 'right', padding: '0 5px'}}>{new Intl.NumberFormat('en-US').format(item.price)}</td>
                      <td style={{border: '1px solid #000000', textAlign: 'right', padding: '0 5px'}}>{item.qty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            }
            {dataDetail && dataDetail.logs && dataDetail.logs.length > 0 &&
              <Timeline sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                }}>
                {dataDetail.logs.map((item, index) => (
                  <TimelineItem key={index}>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography variant="body1">
                        {moment(item.dateupdate).format('DD/MM/YYYY HH:mm:ss')}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.fullname}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.field}: {item.contents}
                      </Typography>
                      {item.remarks && <Typography variant="body2" color="text.secondary">
                        Remarks: {item.remarks}
                      </Typography>}
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </Timeline>
            }

					</div>
				</Popover>
        {/* <CustomTable /> */}
      </div>

      <ImportExcel open={openImport} setOpen={setOpenImport} />

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        severity={snackContent.includes('Lỗi') || snackContent.includes('Chưa')?'error':'success'}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}